const SOCIAL_NETWORK_TYPE = [
  { value: 'facebook', label: 'Facebook' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'instagram', label: 'Instagram' },
];

const PRODUCT_TYPES_LIST = [
  { value: 'gift_card', label: 'Gift card' },
  { value: 'digitize', label: 'Digitize' },
  { value: 'enhance', label: 'Enhance' },
  { value: 'shipping', label: 'Shipping' },
  { value: 'photo_art', label: 'Photo Art' },
];

const PRODUCTS_LIST = {
  digitize: [
    'tape_transfer',
    'film_transfer',
    'audio_transfer',
    'digital_transfer',
    'photo_scan',
    'forever_cloud',
  ],
  gift_card: ['gift_card'],
  enhance: [
    'photo_restoration',
    'photo_colorization',
    'photo_retouching',
  ],
  shipping: [
    'free_shipping',
    'easy_home_ship_kit',
    'local_pickup',
    'easy_scan_ship_kit',
    'photo_art_ship_kit',
    'return_shipping',
    'in_store',
    'store_drop_of',
    'digital_download',
    'trial_ship_kit',
    'email_delivery',
  ],
};

const PRODUCT_TYPES = {
  giftCard: 'gift_card',
  wrapper: 'wrapper',
  digitize: 'digitize',
  enhance: 'enhance',
  deliveries: 'shipping',
  enhance_prints: 'enhance_prints',
  photoArt: 'photo_art',
};

const PRODUCT_PAGES = [
  { value: 'photo_art', label: 'Create page' },
  { value: 'photo_restoration', label: 'Photo restoration' },
  { value: 'photo_colorization', label: 'Photo colorization' },
  { value: 'photo_retouching', label: 'Photo retouching' },
  { value: 'proof', label: 'Proof page' },
];
const ARTICLE = 'articles_list';
const PRODUCT = 'product';
const CUSTOM_ADS = 'custom_ads';
const SOCIAL_NETWORK = 'social_network';

export default {
  SOCIAL_NETWORK_TYPE,
  PRODUCT_TYPES_LIST,
  PRODUCTS_LIST,
  PRODUCT_TYPES,
  PRODUCT_PAGES,
  ARTICLE,
  PRODUCT,
  CUSTOM_ADS,
  SOCIAL_NETWORK,
};
